import { useEffect, useRef, useState } from 'react';
import { SlideContainer } from './styles';

type SlideDownBodyProps = {
  children: React.ReactNode;
  isOpen: boolean;
};

export const SlideDown = ({ children, isOpen }: SlideDownBodyProps) => {
  const contentDiv = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (isOpen) {
      setHeight(contentDiv.current?.scrollHeight ?? 0);
    } else {
      setHeight(0);
    }

    return () => {
      setHeight(0); // Reset height when component unmounts
    };
  }, [isOpen]);

  return (
    <SlideContainer height={height}>
      <div ref={contentDiv}>{children}</div>
    </SlideContainer>
  );
};
